import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Calendar, Brain, TrendingDown } from 'lucide-react';
const urgencyPoints = [{
  icon: Calendar,
  title: 'Seu casamento tem data',
  description: 'Cada dia que passa é um dia a menos para resolver isso. Quanto antes você decidir, mais tranquila você fica.'
}, {
  icon: Brain,
  title: 'A ansiedade só cresce',
  description: 'Você sabe que precisa resolver. Quanto mais você adia, mais essa preocupação ocupa espaço na sua mente.'
}, {
  icon: TrendingDown,
  title: 'Tempo é o recurso mais escasso',
  description: 'Você tem mil coisas para resolver no casamento. Quanto antes tirar as lembrancinhas da lista, melhor.'
}, {
  icon: Clock,
  title: 'Decisão rápida = menos estresse',
  description: 'Imagine acordar amanhã sabendo exatamente o que vai fazer. Essa sensação de alívio não tem preço.'
}];
export function UrgencySection() {
  return <section className="py-12 md:py-20 bg-stone-50" data-id="element-348">
      <div className="max-w-5xl mx-auto px-4 md:px-6" data-id="element-349">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 md:mb-14" data-id="element-350">
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-stone-900 mb-4 md:mb-6" data-id="element-351">
            "Posso Fazer Isso Hoje?"
          </h2>
          <p className="text-lg md:text-xl text-stone-600 max-w-3xl mx-auto" data-id="element-352">
            A resposta é sim. E aqui está por que você deveria:
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-5 md:gap-7 mb-10 md:mb-14" data-id="element-353">
          {urgencyPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.6
        }} className="bg-gradient-to-br from-amber-50 to-yellow-50 p-5 md:p-7 rounded-xl md:rounded-2xl shadow-lg" data-id="element-354">
              <div className="flex items-start gap-4" data-id="element-355">
                <div className="bg-white p-3 rounded-xl shadow-md flex-shrink-0" data-id="element-356">
                  <point.icon className="w-6 h-6 md:w-7 md:h-7 text-amber-600" data-id="element-357" />
                </div>
                <div data-id="element-358">
                  <h3 className="text-base md:text-lg font-bold text-stone-900 mb-2 md:mb-3" data-id="element-359">
                    {point.title}
                  </h3>
                  <p className="text-sm md:text-base text-stone-700 leading-relaxed" data-id="element-360">
                    {point.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5,
        duration: 0.6
      }} className="bg-gradient-to-r from-amber-500 to-yellow-600 p-6 md:p-10 rounded-2xl md:rounded-3xl shadow-2xl text-white text-center" data-id="element-361">
          <h3 className="text-xl md:text-3xl font-bold mb-4 md:mb-6" data-id="element-362">
            Resolva Isso Agora. Durma Tranquila Hoje à Noite.
          </h3>

          <p className="text-base md:text-xl leading-relaxed max-w-3xl mx-auto" data-id="element-363">
            Em menos de 5 minutos, você terá acesso a 40 ideias prontas. Em
            menos de 1 hora, você já terá escolhido as suas favoritas. E amanhã?
            Amanhã você acorda com essa preocupação{' '}
            <span className="font-bold" data-id="element-364">completamente resolvida</span>.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.7,
        duration: 0.6
      }} className="mt-8 md:mt-10 text-center" data-id="element-365">
          <p className="text-base md:text-lg text-stone-600" data-id="element-366">
            Você está a{' '}
            <span className="font-bold text-amber-700" data-id="element-367">um clique</span> de
            transformar essa ansiedade em confiança.
          </p>
        </motion.div>
      </div>
    </section>;
}